import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User, Organization } from '@sparqplug/types';

interface AuthState {
  user: User | null;
  organization: Organization | null;
  accessToken: string | null;
  isLoading: boolean;

  setUser: (user: User | null) => void;
  setOrganization: (org: Organization | null) => void;
  setAccessToken: (token: string | null) => void;
  setLoading: (loading: boolean) => void;
  signOut: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      organization: null,
      accessToken: null,
      isLoading: true,

      setUser: (user) => set({ user }),
      setOrganization: (organization) => set({ organization }),
      setAccessToken: (accessToken) => {
        if (typeof window !== 'undefined') {
          if (accessToken) window.sessionStorage.setItem('sparqplug_access_token', accessToken);
          else window.sessionStorage.removeItem('sparqplug_access_token');
        }
        set({ accessToken });
      },
      setLoading: (isLoading) => set({ isLoading }),
      signOut: () => {
        if (typeof window !== 'undefined') window.sessionStorage.removeItem('sparqplug_access_token');
        set({ user: null, organization: null, accessToken: null, isLoading: false });
      },
    }),
    {
      name: 'sparqplug-auth',
      partialize: (state) => ({
        user: state.user,
        organization: state.organization,
      }),
    },
  ),
);
